module.exports = __webpack_public_path__ + "img/logo_dark.2ae103dd.png";